import { PumpeWCActionType } from '../../actions/ActionType'

const initialState = {
    loading: false,
    objeckt:[]
}

type action = {
    type: string
    objeckt?: any
}

const PumpeWCReducer = (state = initialState, action: action) => {
    switch (action.type) {
        case PumpeWCActionType.PumpeWC_INIT:
            return {
                ...state,
                objeckt:action.objeckt,
                loading: true
            }
        default:
            return state
    }
}

export default PumpeWCReducer
